import { createBrowserHistory, createMemoryHistory } from 'history'
import { ExecutionEnvironment } from './utils/ExecutionEnvironment'

export const history = ExecutionEnvironment.isSsr ? createMemoryHistory() : createBrowserHistory()
